import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/districts'

const DistrictsApiV2 = {
  /**
   * Get list of `District`
   * @param {object} filters possible value: { province_id: number, province_name: string, city_id: number, city_name: string }
   * @return {object} Collection of `Districts`
   */
  get: async (filters) => {
    const params   = QueryParamsUtil.format(null, filters)
    const response = axios.get(API_PATH, { params })
    return response
  }
}

export default DistrictsApiV2
